enum CampaignMode {
    RUN,
    RESULTS,
    TEMPLATES,
};

export default CampaignMode;